// 页面加载完成后初始化
document.addEventListener("DOMContentLoaded", () => {
  var tabAccordion = document.querySelectorAll('.tab-item');
  var imgList = document.querySelectorAll('.image-item');
  var currrentIndex = 1;

  const activeTab = document.querySelector('.tab-item.is-active') || tabAccordion[0]; // 兜底：默认第一个
  if (activeTab) {
    currentIndex = activeTab.getAttribute('data-index');
    clearActive();
    showImage(currentIndex);
  }

  tabAccordion.forEach(tab => {
    tab.addEventListener('click', function () {
      currentIndex = this.getAttribute('data-index');
      clearActive();
      showImage(currentIndex);
    });
  });

  function showImage(index) {
    const item = document.querySelector('.image-item[data-index="' + index + '"]');
    if (item) {
      item.classList.add('t4s-active');
    }
  }
  // 清除active
  function clearActive(index) {
    for (i = 0; i < imgList.length; i++) {
      imgList[i].classList.remove('t4s-active');
    }
  }

  // 计算tab内容高度
  const containerHeight = document.getElementById('accordion-image').offsetHeight; // 获取容器高度
  // heading: 34 + 30px, tab: 44px
  const tabItemCount = tabAccordion.length; // 获取tab的数量，以此乘以高度
  const tabContentHeight = containerHeight - 64 - (tabItemCount * 54);
  document.querySelectorAll('#accordion-image .t4s-tab-content').forEach(e => {
    e.style.maxHeight = `${tabContentHeight}px`;
  });
});